import { ReactNode } from 'react';

const CategoriesContainer = ({ children }: { children: ReactNode }) => {
  return (
    <div className="v2-w-full">
      <h3 className="v2-font-medium v2-font-sweet-sans-pro-medium v2-text-[#101828] v2-text-sm v2-mb-[12px]">
        Popular Categories
      </h3>
      <div className="v2-grid v2-grid-cols-7 md:v2-grid-cols-7 sm:v2-grid-cols-2 xs:v2-grid-cols-2 v2-gap-[12px] md:v2-gap-[12px] sm:v2-gap-[6px] xs:v2-gap-[6px]">
        {children}
      </div>
    </div>
  );
};

export default CategoriesContainer;
